























































import Vue from 'vue';
import { OpenInvestmentTransferScreen } from '@/mixins/get-content-mixins';
import { sso, ACCOUNT_API_SUB_URLS } from '@/api';
import { EventBus } from '@/event-bus';
import { ExtendMixins } from '@/services';
import { MemberAccountResponseModel, AccountDetailResponseModel } from '@/@types/member';
import moment from 'moment';

interface Data {
  clickedBtnId: boolean;
  ssoUrl: string;
  formData: any;
}

export default ExtendMixins(
  OpenInvestmentTransferScreen,
).extend({
  name: 'Investment',
  props: {
    account: {
      type: Object as () => MemberAccountResponseModel,
      required: true,
    },
    accountDetail: {
      type: Object as () => AccountDetailResponseModel,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      ssoUrl: '',
      formData: {},
    };
  },
  computed: {
    futureContributionPercentage(): string {
      return `${this.account.investmentFutureContributionPercentage}%`;
    },
    investmentOverThreshold(): boolean {
      return (
        this.account.allowInvestments &&
        !this.account.hasInvestmentAccount &&
        this.account.availableBalance > this.account.investmentThreshold
      );
    },
    investmentUnderThreshold(): boolean {
      return (
        this.account.allowInvestments &&
        !this.account.hasInvestmentAccount &&
        this.account.availableBalance < this.account.investmentThreshold
      );
    },
    investmentTransferActionText(): string {
      return this.account.hasInvestmentAccount
        ? this.$options.filters.t(
            'account-investment_action_transfer-to-investment-account',
          )
        : this.$options.filters.t(
            'account-investment_action_open-investment-account',
          );
    },
    disableInvestmentAccountBtn(): boolean {
      return this.investmentUnderThreshold || this.accountDetail.isPendingOpenInvAcct || this.account.isMigratedInd || this.afterLastInvestmentDate;
    },
    disableInvestmentTransferBtn(): boolean {
      return this.investmentUnderThreshold || this.accountDetail.isPendingOpenInvAcct || this.account.isMigratedInd;
    },
    lastInvestmentDate(): string {
      return this.$store.getters.groupMigrationDates.lastInvestmentDate;
    },
    afterLastInvestmentDate(): boolean {
      const lastInvestmentDate = moment(this.lastInvestmentDate);
      const today = moment().startOf('day');
      return today.isSameOrAfter(lastInvestmentDate);
    },
  },
  methods: {
    openInvestmentTransfer(): void {
      this.openInvestmentTransferScreen({
        account: this.account,
        changeContribution: false,
      });
    },
    getSchwabSSO(): void {
      this.isLoading = true;
      sso
        .post(`${ACCOUNT_API_SUB_URLS.accounts}/${this.account.id}/schwabSso`, { }, {
          params: { investmentCode: this.account.investmentCode },
        })
        .then((response) => {
          this.ssoUrl = response.data.url;
          this.formData = response.data.formData;

          this.$nextTick(() => {
            this.isLoading = false;
            (this.$refs.sso as any).submit();

            // GTM Event - Exit to Investment Account
            window.dataLayer.push({
              event: 'exitToInvestmentSite',
            });
          });
        })
        .catch(() => {
          this.isLoading = false;

          EventBus.$emit('openModal', 'Error', {
            message: 'sso-redirect-error_unable-to-perform-redirect',
          });
        });
    },
  },
});
